import { cn } from '@/lib/utils';
import Button from '@ui/Button';
import getQualifiedImageUrl from '@utils/imageUrlProcessor';
import { cva, cx } from 'cva';
import { isEmpty, isString } from 'lodash-es';
import React from 'react';
import { MdOutlineChevronLeft, MdOutlineChevronRight } from 'react-icons/md';

const selectedPostImages = cva('selectedPostImages', {
  variants: {
    size: {
      xs: ['h-32'],
      sm: ['h-44'],
      md: ['h-56'],
      lg: ['h-72'],
    },
  },
  defaultVariants: {
    size: 'lg',
  },
});

function SelectedPostImages(props) {
  const { size, images } = props;
  const [currentImageIndex, setCurrentImageIndex] = React.useState(0);

  const [postImages, setPostImages] = React.useState([]);

  const styles = selectedPostImages({ size });

  React.useEffect(() => {
    if (!isEmpty(images)) {
      setPostImages(
        images.map((image) => {
          if (isString(image)) {
            return {
              preview: getQualifiedImageUrl(image),
            };
          }
          return image;
        }),
      );
    } else {
      setPostImages([]);
    }
  }, [images]);

  const handleNextClick = () => {
    // slideToNextItem();
    if (currentImageIndex < postImages.length - 1) {
      setCurrentImageIndex(currentImageIndex + 1);
    }
  };

  const handlePrevClick = () => {
    // slideToPrevItem();
    if (currentImageIndex > 0) {
      setCurrentImageIndex(currentImageIndex - 1);
    }
  };

  if (isEmpty(postImages)) {
    return null;
  }

  return (
    <div className="relative flex w-full flex-1 flex-row items-center justify-start gap-2">
      <div className="absolute left-1 top-1/2">
        <Button
          variant="icon"
          className={cx(
            '!bg-body-background !p-1 opacity-60 hover:opacity-90',
            currentImageIndex === 0 && 'hidden',
          )}
          onClick={handlePrevClick}>
          <MdOutlineChevronLeft className="h-6 w-6" />
        </Button>
      </div>
      <div className="flex-1 overflow-hidden">
        <div
          className={cn(
            'flex h-full w-full items-center justify-start overflow-hidden',
            styles,
          )}>
          <img
            src={
              postImages[currentImageIndex].preview ||
              postImages[currentImageIndex].url
            }
            alt={`image${currentImageIndex}`}
            className="h-full w-full object-contain"
          />
        </div>
      </div>
      <div className="absolute right-1 top-1/2">
        <Button
          variant="icon"
          onClick={handleNextClick}
          className={cx(
            '!bg-body-background !p-1 opacity-60 hover:opacity-90',
            currentImageIndex === postImages.length - 1 && 'hidden',
          )}>
          <MdOutlineChevronRight className="h-6 w-6" />
        </Button>
      </div>
    </div>
  );
}

export default SelectedPostImages;
